// 统一判断当前环境
export const getEnv = () => {
  const host = window.location.hostname;
  // 本地 / 测试环境
  if (host.includes("localhost") || host.includes("test")) {
    return "test";
  }
  // 预发布环境（dev/uat）
  if (host.includes("dev") || host.includes("uat")) {
    return "pre";
  }
  // 生产环境
  return "pro";
};

// 三环境配置表（集中管理，修改超方便）
const ENV_CONFIG = {
  test: {
    BaseUrl: "https://test-play.sallochat.com",// 'https://test2-play.sallochat.com' //  test2环境
    ImgBaseUrl: "https://test-img.sallochat.com",
    WebUrl: "https://test-www.sallochat.com",
    SignatureKey: "W5Y2qfRCXJw6MXP7",
    DecodeKey: "SVZeNfzZN3EQcUtQ",
    ReferenceUrl: "https://test-m.sallochat.com",
  },
  pre: {
    BaseUrl: "https://dev-play.sallochat.com",
    ImgBaseUrl: "https://dev-img.sallochat.com", // 预发布图片地址（可按需求修改）
    WebUrl: "https://dev-www.sallochat.com",     // 预发布官网地址（可按需求修改）
    SignatureKey: "W1bctaVidKfpcxbQ",       // 预发布密钥（自行修改）
    DecodeKey: "IImtpZCI6IUwM2E1",          // 预发布密钥（自行修改）    
    ReferenceUrl: "https://dev-m.sallochat.com",             
  },
  pro: {
    BaseUrl: "https://play.sallochat.com",
    ImgBaseUrl: "https://img.sallochat.com",
    WebUrl: "https://www.sallochat.com",
    SignatureKey: "W1bctaVidKfpcxbQ",
    DecodeKey: "IImtpZCI6IUwM2E1",
    ReferenceUrl: "https://m.sallochat.com",
  },
};

// 当前环境
const CURRENT_ENV = getEnv();
// 导出常量（外部引用方式完全不变！）
export const testFlag = CURRENT_ENV === "test";
// 自动匹配当前环境配置
const CURRENT_CONFIG = ENV_CONFIG[CURRENT_ENV];
export const BaseUrl = CURRENT_CONFIG.BaseUrl;
export const ImgBaseUrl = CURRENT_CONFIG.ImgBaseUrl;
export const WebUrl = CURRENT_CONFIG.WebUrl;
export const OSS_URL = "https://xp-usa-online.s3.amazonaws.com";
export const SignatureKey = CURRENT_CONFIG.SignatureKey;
export const DecodeKey = CURRENT_CONFIG.DecodeKey;
export const ReferenceUrl = CURRENT_CONFIG.ReferenceUrl;
export const ReportSDK = testFlag
  ? "//webtracksdk-test.stnts.com/websdkv2.4.test.js"
  : "//dtsdk.xposeai.cc/websdkv2.4.js"; //pro
export const ReportDes = testFlag ? void 0 : "//dssp.xposeai.cc"; //pro
export const IMConfig = {
  appkey: testFlag ? "4c8b36a496a79f5d19e9ffeeb89e4ec7" : "7f0f8b104b54639d756aaa041359497c", //pro
  debugLevel: "warn",
  apiVersion: "v2",
};
export const GoogleAuthClientId = "671980133687-s4a5icivmrk6u3ug3s9khq9uvghcemv7.apps.googleusercontent.com";
export const DecodePrefix = "DAIDAI-";
export const RequestBaseSignature = {
  source: 6, //h5
  vnum: "1",
  companyCode: "SC_302",
  appCode: "SC_302",
};
export const RequestHeaderExts = {
  appSubCode: "SALLO",
  version: "1.0.0",
};
export const NSFWBlackList = ["99999"];

export const DefaultChannel = "PIDUDicBjEaa";
export const ChannelCacheKey = "_scck";
export const AuthCacheKey = "_sack";
export const AuthIdCacheKey = "_saick";
export const UCUidCacheKey = "_suuck";
export const LangCacheKey = "_slck";
export const NSFWCacheKey = "_snck";
export const ProductId = 320007;

export const BingKeyWord = "_bing_keyword";
export const BingMsclkid = "_bing_msclkid";
export const BingMsclkidCreationTime = "_bing_msclkid_creationTime";
export const BingQuery = "_bing_query";

export const GoogleGclid = "_gclid";
export const GoogleGclidCreationTime = "_gclid_creationTime";
export const GoogleKeyword = "_ggkeyword";
export const GoogleMatchType = "_ggmatchtype";

export const UuidKey = "_uuid";
// 18+弹窗协议
export const ADULT_AGREE = "_adult_agree";
export const FIRST_UPLOAD_IMAGE = "_first_upload_image";
export const LAST_FACE_IMAGE = "_last_face_image";
export const LAST_TARGET_IMAGE = "_last_target_image";
export const FIRST_SEX_UPLOAD_IMAGE = "_first_sex_upload_image";
export const TEXT_TO_IMAGE_INPUT = "_text_to_image_input";
export const FACE_AUTH_URL = "_face_auth_url";
